// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__PJExM","row":"ProcedureTreatmentSummary_row__2USh4"};